// extracted by mini-css-extract-plugin
module.exports = {"starActiveColor":"#7811c9","starBorderColor":"#7811c9","pointColor":"#b990da"};